import { PreviewIcon } from '@/assets/icons';
import { CommonActions, useAppDispatch } from '@/stores';
import { insertObjectIf } from '@/utils';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import { TableLinkTo } from '..';
import Tooltip from '../common/tooltip';
import DefineDocumentWrite from '.';
import {
	DefineDocumentWriteButtonProps,
	IProps as IDefineDocumentWriteProps,
} from './define-document-write.type';

const PreviewFileButton = (props: DefineDocumentWriteButtonProps) => {
	const dispatch = useAppDispatch();
	const [open, setOpen] = useState(false);

	const defineDocumentWriteModal =
		useRef<FunctionComponent<IDefineDocumentWriteProps>>();

	const onOpenModal = useCallback(() => {
		if (!defineDocumentWriteModal.current) {
			defineDocumentWriteModal.current = DefineDocumentWrite;
		}

		setOpen(true);
	}, []);

	const onCloseModal = useCallback(() => {
		setOpen(false);
	}, []);

	const onClickPreview = useCallback(() => {
		if (props.fileId) {
			dispatch(
				CommonActions.getDocumentJsonContentRequest({
					id: Number(props.fileId),
					callback: () => {
						onOpenModal();
					},
				})
			);
		}
	}, [props.fileId]);

	return (
		<>
			<Tooltip title="미리보기">
				{props.link ? (
					<TableLinkTo
						label={props.label}
						{...insertObjectIf(!props.readonly, {
							onClick: onClickPreview,
						})}
					/>
				) : (
					<PreviewIcon className="cursor-pointer" onClick={onClickPreview} />
				)}
			</Tooltip>
			{open && defineDocumentWriteModal.current && (
				<defineDocumentWriteModal.current
					{...{ ...props, open, onCloseModal }}
				/>
			)}
		</>
	);
};

export default memo(PreviewFileButton);
